/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality. 
 */

import supportingDocs from "./supportingDocs";
import claimFields from "./claimFields";

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log('[Initiate claim]...');

    const form = document.querySelector('#form');
    const ssnInputs = form.querySelectorAll('.ssn');

    claimFields.init();

    validateForm({ currentTarget: form });

    form.addEventListener('input', validateForm);

    ssnInputs.forEach(initSSN);

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log('[Load class member]...');
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log('[Process claim]...');
    const participantSSN = document.querySelector('#social_security_number').value;
    const participantDateOfBirth = document.querySelector('#date_of_birth').value;
    return {
        ...claim,
        data: {
            ...claim.data,
            fields: {
                ...claim.data.fields,
                'Participant’s Social Security Number': participantSSN,
                'Participant’s Date of Birth': participantDateOfBirth
            }
        }
    };
}

export function customAddClaimFile(claim) {
    console.log('[Add claim file]...');
    const form = document.querySelector('#form');
    validateForm({ currentTarget: form });
    return claim;
}

/**
 * Validates the form.
 *
 * @param {Event} event - The event to be validated.
 * @returns {void}
 */
function validateForm(event) {
    /**
     * @type {HTMLFormElement}
     */
    const form = event.currentTarget;
    const hasUploadedFiles = supportingDocs.hasUploadedFiles();
    const isBeneficiaryOrSpouse = form.elements.namedItem('beneficiary_type').value === 'Surviving spouse or other beneficiary';
    const isUploadRequired = isBeneficiaryOrSpouse && !hasUploadedFiles;
    // User must submit supporting documents if is beneficiary or spouse
    supportingDocs.setRequired(isUploadRequired);
    supportingDocs.setVisibility(isBeneficiaryOrSpouse);
}

/**
 * Initializes the SSN input.
 *
 * @param {HTMLInputElement} input - The SSN input to be initialized.
 * @returns {void}
 */
function initSSN(input) {
    input.maxLength = 11;
    input.addEventListener('input', validateSSN);
}

function validateSSN(e) {
    /**
     * @type {HTMLInputElement}
     */
    const input = e.target;
    if (input.value === '') return;

    // Format the SSN
    input.value = input.value.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');

    // Validate the SSN
    const pattern = /^\d{3}-\d{2}-\d{4}$/;
    const isValid = pattern.test(input.value);
    input.classList.toggle('is-invalid', !isValid);
    input.setCustomValidity(isValid ? '' : 'Please enter a valid SSN in the format 123-45-6789.');
}